import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiBookMarkedFill } from '@remixicon/react';
import { rootRouteRef } from './routes';

const linkLibraryPage = PageBlueprint.make({
  params: {
    title: 'Link Library',
    icon: <RiBookMarkedFill />,
    path: '/link-library',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/link-library-page').then(m => <m.LinkLibraryPage />),
  },
});

export const headerActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () =>
        import('./components/header-actions').then(m => <m.HeaderActions />),
    }),
});

export const linkLibraryPlugin = createFrontendPlugin({
  pluginId: 'link-library',
  extensions: [linkLibraryPage, headerActions],
  routes: {
    root: rootRouteRef,
  },
});
